import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminRoomsList() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // EDIT STATE
  const [editingRoom, setEditingRoom] = useState(null);
  const [form, setForm] = useState({
    name: "",
    capacity: "",
    price: "",
    description: "",
  });
  const [file, setFile] = useState(null);

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/rooms/all`);
      const data = await res.json();
      setRooms(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch rooms");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this room?")) return;

    try {
      const res = await fetch(`${BASE_URL}/rooms/delete/${id}`, {
        method: "DELETE",
      });

      const data = await res.json();

      if (res.ok) {
        alert("Deleted successfully");
        fetchRooms();
      } else {
        alert(data.error);
      }
    } catch (err) {
      alert("Server error");
    }
  };

  // OPEN EDIT MODAL
  const openEdit = (room) => {
    setEditingRoom(room.id);
    setForm({
      name: room.name,
      capacity: room.capacity,
      price: room.price,
      description: room.description || "",
    });
  };
const addBtn = {
  padding: "10px 18px",
  background: "#3b82f6",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};
  // UPDATE API
  const updateRoom = async () => {
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("capacity", form.capacity);
    formData.append("price", form.price);
    formData.append("description", form.description);

    if (file) {
      formData.append("image_url", file);
    }

    const res = await fetch(`${BASE_URL}/rooms/update/${editingRoom}`, {
      method: "PUT",
      body: formData,
    });

    const data = await res.json();

    if (res.ok) {
      alert("Room updated successfully");
      setEditingRoom(null);
      setFile(null);
      fetchRooms();
    } else {
      alert(data.error);
    }
  };

  if (loading) {
    return (
      <div style={loaderStyle}>
        Loading Rooms...
      </div>
    );
  }

  return (
    <div style={pageStyle}>
<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <h1 style={titleStyle}>🏨 Rooms Management</h1>

  <button
    onClick={() => navigate("/admin/rooms")}
    style={addBtn}
  >
    + Add Room
  </button>
</div>
      <div style={grid}>
        {rooms.map((r) => (
          <div key={r.id} style={card}>
            <img src={r.image_url} style={img} />

            <div style={{ padding: 15 }}>
              <h3>{r.name}</h3>
              <p>👥 Capacity: {r.capacity}</p>
              <p>💰 ₹{r.price}</p>

              <div style={btnRow}>
                <button style={editBtn} onClick={() => openEdit(r)}>
                  Edit
                </button>

                <button
                  style={deleteBtn}
                  onClick={() => handleDelete(r.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {editingRoom && (
        <div style={modalOverlay}>
          <div style={modal}>
            <h2>Edit Room</h2>

            <input
              style={input}
              placeholder="Name"
              value={form.name}
              onChange={(e) =>
                setForm({ ...form, name: e.target.value })
              }
            />

            <input
              style={input}
              placeholder="Capacity"
              value={form.capacity}
              onChange={(e) =>
                setForm({ ...form, capacity: e.target.value })
              }
            />

            <input
              style={input}
              placeholder="Price"
              value={form.price}
              onChange={(e) =>
                setForm({ ...form, price: e.target.value })
              }
            />

            <textarea
              style={input}
              placeholder="Description"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />

            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <div style={btnRow}>
              <button style={saveBtn} onClick={updateRoom}>
                Save
              </button>

              <button
                style={cancelBtn}
                onClick={() => setEditingRoom(null)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  padding: 30,
  fontFamily: "Segoe UI",
  background: "#f4f6f8",
  minHeight: "100vh",
};

const titleStyle = {
  textAlign: "center",
  marginBottom: 30,
  fontSize: 32,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: 20,
};

const card = {
  background: "#fff",
  borderRadius: 15,
  overflow: "hidden",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
};

const img = {
  width: "100%",
  height: 180,
  objectFit: "cover",
};

const btnRow = {
  display: "flex",
  gap: 10,
  marginTop: 10,
};

const editBtn = {
  flex: 1,
  padding: 10,
  border: "none",
  background: "#10b981",
  color: "#fff",
  borderRadius: 8,
  cursor: "pointer",
};

const deleteBtn = {
  flex: 1,
  padding: 10,
  border: "none",
  background: "#ef4444",
  color: "#fff",
  borderRadius: 8,
  cursor: "pointer",
};

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modal = {
  background: "#fff",
  padding: 25,
  borderRadius: 12,
  width: 400,
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const input = {
  padding: 10,
  border: "1px solid #ccc",
  borderRadius: 8,
};

const saveBtn = {
  flex: 1,
  padding: 10,
  background: "#4f46e5",
  color: "#fff",
  border: "none",
  borderRadius: 8,
};

const cancelBtn = {
  flex: 1,
  padding: 10,
  background: "#6b7280",
  color: "#fff",
  border: "none",
  borderRadius: 8,
};

const loaderStyle = {
  textAlign: "center",
  padding: 100,
  fontSize: 20,
};